module.exports = {
  company: "金砖国际渔业交易平台",
  copyright: "©2023 ICP证：京ICP备16005856号-11",
  lang1: "首页",
  lang2: "交易中心",
  lang3: "我要发布",
  lang4: "数据中心",
  lang5: "特色水产品",
  lang6: "平台规则",
  lang7: "关于项目",
  lang8: "个人中心",
  lang9: "登录/注册",
  lang10: "请选择",
  lang11: "发布",
  lang12: "我要卖货",
  lang13: "我要买货",
  lang14: "客服咨询",
  lang15: "工作日：8:30-17:30在线",
  lang16: "电话咨询",
  lang17: "快来发布货源吧～",
  lang18: "快来发布订单吧～",
  lang19: "点击按钮快速发布交易或者",
  lang20: "告诉我们你的诉求",
  lang21: "平台将快速响应～",
  lang22: "聊一聊",
  lang23: "请先开户",
  lang24: "厦门火炬高新区软件园三期诚毅北大街52号303室之五",
  lang25: "微信扫一扫",
  lang26: "当前会员**到期",
  lang27: "暂未购买鱿鱼专区数据服务，点击开通",
  lang28: "操作成功!",
  lang29: "请输入密码",
  lang30: "请输入6位密码",
  lang40: "查看更多",
  lang41: "实时汇率",
  lang42: "更多",
  lang43: "币种",
  lang44: "汇率",
  lang45: "柴油价格",
  lang46: "港口",
  lang47: "日期",
  lang48: "世界集装箱运转指数",
  lang49: "航线",
  lang50: "周环比",
  lang51: "年同比",
  lang52: "数据赋能",
  lang53: "智赢未来",
  lang54: "实时数据中枢",
  lang55: "覆盖全市场动态报价系统",
  lang56: "小时级更新行情价格",
  lang57: "区域精析引擎",
  lang58: "提供石岛、舟山、福建重点区域",
  lang59: "行情走势图",
  lang60: "趋势预测模型",
  lang61: "集成历史数据图表",
  lang62: "构建价格波动预测体系",
  lang63: "决策支持工具",
  lang64: "配套可视化数据看板",
  lang65: "数据中心能为客户带来什么？",
  lang66: "提供投资决策",
  lang67: "精准捕捉价格拐点,优化资产配置策略",
  lang68: "垂直企业战略",
  lang69: "深度解析区域市场特征,科学规划业务布局",
  lang70: "全域风险管理",
  lang71: "构建价格预警机制,降低市场波动影响",
  lang72: "开启数据订阅",
  lang73: "抢占市场先机",
  lang74: "立即订阅",
  lang75: "提前还款",
  lang76: "结清金额（元）",
  lang77: "全部还款",
  lang78: "申请提前还款本金（元）",
  lang79: "剩余未还本金（元）",
  lang80: "还款账户",
  lang81: "还款账号",
  lang82: "申请扣款",
  lang83: "请输入还款金额",
  lang84: "还款记录",
  lang85: "剩余本金（元）",
  lang86: "本金（元）",
  lang87: "利息（元）",
  lang88: "还款时间",
  lang89: "还款金额（元）",
  lang90: "交易短描述",
  lang91: "利息罚息（元）",
  lang92: "本金罚息（元）",
  lang93: "费用（元）",
  lang94: "本金余额（元）",
  lang95: "请依次完成支付动作",
  lang96: "点击此处",
  lang97: "到跳转的网页进行支付",
  lang98: "支付完成后复制支付流水号填入",
  lang99: "输入支付流水号",
  lang100: "上传支付凭证照片",
  lang101: "点击上传",
  lang102: "确认上传",
  lang103: "最多上传1张图片,请先删除再上传",
  lang104: "请输入流水账号",
  lang105: "请上传支付凭证",
  lang106: "请核对订单",
  lang107: "成交价",
  lang108: "价格",
  lang109: "元",
  lang110: "商品总价",
  lang111: "实际交割重量",
  lang112: "服务费",
  lang113: "订单编号",
  lang114: "复制",
  lang115: "创建时间",
  lang116: "支付方式",
  lang117: "取消",
  lang118: "确认支付",
  lang119: "合同列表",
  lang120: "刷新",
  lang121: "合同名称",
  lang122: "状态",
  lang123: "未签署",
  lang124: "签署中",
  lang125: "签署完成",
  lang126: "操作",
  lang127: "去签署",
  lang128: "查看合同",
  lang129: "批量签署",
  lang130: "线上合同签署短信已发送...",
  lang131: "接收手机号",
  lang132: "请留意手机短信，并及时签署。",
  lang133: "我知道了",
  lang134: "报名货源详情",
  lang135: "货源名称",
  lang136: "单位",
  lang137: "重量",
  lang138: "货源地",
  lang139: "货源描述",
  lang140: "报名编号",
  lang141: "提交时间",
  lang142: "拒绝时间",
  lang143: "确认时间",
  lang144: "申请提货",
  lang145: "总吨数",
  lang146: "在提吨数",
  lang147: "已提吨数",
  lang148: "剩余可提吨数",
  lang149: "提货记录",
  lang150: "提货状态",
  lang151: "预提吨数",
  lang152: "实际出库吨数",
  lang153: "提货日期",
  lang154: "出库日期",
  lang155: "申请时间",
  lang156: "应付金额",
  lang157: "费用详情",
  lang158: "《费用确认单》",
  lang159: "出库单",
  lang160: "填写《费用确认单》",
  lang161: "查看《费用确认单》后支付",
  lang162: "上传出库单",
  lang163: "全部",
  lang164: "待卖家回传费用确认单",
  lang165: "待买家支付",
  lang166: "等待卖家上传出库单",
  lang167: "已完成提货",
  lang168: "上传成功",
  lang169: "填写费用确认单",
  lang170: "买家申请",
  lang171: "买家客户",
  lang172: "预计提货日期",
  lang173: "所在冷库",
  lang174: "基准日",
  lang175: "费用确认单",
  lang176: "可提货日期",
  lang177: "选择日期",
  lang178: "天数",
  lang179: "件数",
  lang180: "点击输入正整数",
  lang181: "毛重（吨）",
  lang182: "点击输入数字，支持小数点后4位",
  lang183: "净重（吨）",
  lang184: "成交价（元/吨）",
  lang185: "元/吨（不可调整）",
  lang186: "货款（元）",
  lang187: "系统自动计算，无需填写",
  lang188: "预付款（元）",
  lang189: "重置",
  lang190: "基础增价",
  lang191: "点击填写",
  lang192: "仓储费",
  lang193: "出库操作费",
  lang194: "保费",
  lang195: "点击输入数字，支持小数点后2位",
  lang196: "其他",
  lang197: "若需要减少买家支付费用，请填写负数",
  lang198: "合计应付（元）",
  lang199: "预览图片",
  lang200: "发送费用确认单",
  lang201: "费用确认单预览",
  lang202: "返回修改",
  lang203: "发送给买家",
  lang204: "请输入件数",
  lang205: "请输入整数",
  lang206: "请输入基础增价",
  lang207: "请输入净重（吨）",
  lang208: "请输入仓储费",
  lang209: "请输入出库操作费",
  lang210: "请输入保费",
  lang211: "请输入其他费用",
  lang212: "发送成功",
  lang213: "仓储费单价",
  lang214: "出库操作费单价",
  lang215: "不超过剩余库存",
  lang216: "确认提货",
  lang217: "生成",
  lang218: "即将开始",
  lang219: "已成交",
  lang220: "流拍",
  lang221: "进行中",
  lang222: "到货港",
  lang223: "收货地",
  lang224: "可拆",
  lang225: "剩余",
  lang226: "起拍价",
  lang227: "美元",
  lang228: "专属客服",
  lang229: "联系品控",
  lang230: "查看卖方货源",
  lang231: "开始支付",
  lang232: "已装车",
  lang233: "确认装车",
  lang234: "请拨打电话：",
  lang235: "确定",
  lang236: "文件下载失败",
  lang237: "文件签署失败",
  lang238: "上传人",
  lang239: "暂无定价",
  lang240: "请输入内容",
  lang241: "下架",
  lang242: "再来一单",
  lang243: "编辑后重新上架",
  lang245: "查看订单",
  lang246: "再次上架",
  lang247: "删除",
  lang248: "改价",
  lang249: "确定修改",
  lang250: "报名货源",
  lang251: "编辑",
  lang252: "此操作将下架该货源, 是否继续?",
  lang253: "提示",
  lang254: "下架成功!",
  lang255: "此操作将删除该货源, 是否继续?",
  lang256: "删除成功!",
  lang257: "即将开拍",
  lang258: "货源",
  lang259: "备注",
  lang260: "当前价",
  lang261: "成交",
  lang262: "起拍",
  lang263: "开拍",
  lang264: "结束",
  lang265: "距开始",
  lang266: "距结束",
  lang267: "置顶",
  lang268: "报盘中",
  lang269: "当前",
  lang270: "我要减价",
  lang271: "我要加价",
  lang272: "最新价格",
  lang273: "加价幅度",
  lang274: "出价方",
  lang275: "新增报名",
  lang276: "请选择出价方",
  lang277: "出价成功",
  lang278: "绑定银行卡",
  lang279: "账户类型",
  lang280: "账户名称",
  lang281: "银行卡号",
  lang282: "请输入",
  lang283: "银行",
  lang284: "开户支行",
  lang285: "银行预留手机号",
  lang286: "提交",
  lang287: "换卡成功",
  lang288: "银行打款",
  lang289: "苏商银行将向填写的对公账户打款",
  lang290: "打款完毕后，请根据银行打款金额进行信息回填",
  lang291: "请选择账户类型",
  lang292: "请输入银行卡号",
  lang293: "请选择银行",
  lang294: "请选择支行",
  lang295: "请输入手机号",
  lang296: "持卡人",
  lang297: "选择主体",
  lang298: "购买的数量",
  lang299: "购买数量不低于",
  lang300: "请输入账号密码",
  lang301: "本次操作不涉及任何金额转账，仅用于确认购买意向",
  lang302: "重设密码",
  lang303: "暂无密码",
  lang304: "前往设置",
  lang305: "交易提示：本单支持线上支付",
  lang306: "交易请求排队中",
  lang307: "您前面有**位客户正在请求交易，",
  lang308: "稍后会有工作人员与您联系，请留意来电信息。",
  lang309: "我知道了",
  lang310: "请选择客户",
  lang311: "请选择主体",
  lang312: "请输入购买吨数",
  lang313: "添加主体",
  lang314: "切换主体",
  lang315: "添加新主体",
  lang316: "请输入支付密码",
  lang317: "付款方式",
  lang318: "苏商银行",
  lang319: "暂无相关数据",
  lang320: "处理报盘",
  lang321: "我的报盘",
  lang322: "报盘（美元/吨）",
  lang323: "认购吨数（吨）",
  lang324: "删除报盘",
  lang325: "提交报盘",
  lang326: "客户",
  lang327: "报盘",
  lang328: "时间",
  lang329: "拒绝",
  lang330: "成交",
  lang331: "隐藏此次处理结果",
  lang332: "提交处理结果",
  lang333: "请输入报盘",
  lang334: "请输入认购吨数",
  lang335: "提交成功",
  lang336: "处理成功",
  lang337: "Q&A 常见问题",
  lang338:
    "关于本平台相关事宜，平台拥有最终解释权。如有疑问，欢迎随时拨打 400 - 101 - 2799 与我们取得联系 。",
  lang339: "我已认证阅读并完全理解以上内容",
  lang340: "买家服务费具体如何收取呢？",
  lang341: "买家服务费的收费标准为 100 元 / 吨。",
  lang342: "买家服务费具体如何收取呢？",
  lang343: "买家服务费的收费标准为 50 元 / 吨。",
  lang344: "买家服务费具体如何收取呢？",
  lang345: "买家服务费的收费标准为 1 元 / 箱。",
  lang346:
    "动态竞价中，系统会根据跟价人数不断出价，直至只有1人跟价（一般情况下），则竞价结束。",
  lang347:
    "普通竞价中，结束前倒计时1分钟之内，如有新的出价，则转入延时竞价，延时1分钟，若在延时倒计时1分钟内，仍有新的报价，则重启1分钟倒计时，以此类推，直到在倒计时结束前无人继续出价，竞价结束，价高者得。",
  lang348: "一定要交保证金吗?",
  lang349:
    "为保证全平台用户权益，卖家、买家都需要缴纳一定额度保证金后才能参与平台交易。卖家在发布交易的时候需要支付2%货值的履约保证金，买家在报名竞价交易时需要支付一定金额的保证金，这一般是由卖家在发布时设置。保证金支付方式均通过线上支付，不支持线下支付。",
  lang350: "什么时候退还保证金?",
  lang351:
    "如果您是卖家，成交前主动下架交易或成交后完成履约，保证金将会原路退回；如果您是买家，若未中拍履约保证金会及时原路退回，若中拍，履约保证金会在您完后履约后，原路退回。",
  lang352: "怎么确定所有人都出完价了?",
  lang353: "如果出现毁约等行为怎么处理?",
  lang354:
    "成交后，买卖双方有任何一方出现毁约行为，除履行客诉流程、保证金扣罚外，该交易商也将纳入交易平台客户黑名单，影响或限制参与后续交易。",
  lang355: "秒",
  lang356: "同意并继续",
  lang357: "快速找货源",
  lang358: "意向货源",
  lang359: "留言板",
  lang360: "帮我找",
  lang361: "需求已发送",
  lang362: "稍后会有专员与您联系",
  lang363: "请注意来电",
  lang364: "工作时间：周一到周六",
  lang365: "了解",
  lang366: "请选择意向货源",
  lang367: "请输入留言内容",
  lang368: "密码设置",
  lang369: "请输入密码",
  lang370: "请再次填写确认",
  lang371: "两次输入不一致，请重新输入",
  lang372: "修改成功",
  lang373: "报名",
  lang374: "主体",
  lang375: "数量",
  lang376: "账号密码",
  lang377: "暂无密码，前往设置",
  lang378: "货源地址",
  lang379: "货源照片/视频",
  lang380: "请点击上传",
  lang381: "货源描述",
  lang382: "温馨提示",
  lang383:
    "请您稍候片刻，交易正在紧急确认中， 稍后会有工作人员与您联系，请留意来电信息。",
  lang384: "视频播放",
  lang385: "请输入",
  lang386: "请选择货源地址",
  lang387: "请输入货源描述",
  lang388: "最多上传9张图片",
  lang389: "当前标的保证金",
  lang390: "您的账户余额",
  lang391: "报名竞价即表示同意冻结对应保证金；",
  lang392: "若未获拍，冻结的保证金会自动退回；",
  lang393: "若成功获拍，冻结的保证金会在订单确认生成后退回；",
  lang394: "若您成功拍下后未履约，冻结的保证金将被扣除。",
  lang395: "取消报名",
  lang396: "去转入",
  lang397: "再考虑一下",
  lang398: "确认报名",
  lang399: "请先选择主体",
  lang400: "已取消报名",
  lang401: "新手必看演示",
  lang402: "开市时间：周一至周六（节假日除外） 9:00-11:30 13:00-16:30",
  lang403: "今日开市",
  lang404: "今日休市",
  lang405: "全天无竞价",
  lang406: "全天休市 无场次安排",
  lang407: "鱿鱼专区",
  lang408: "鳕鱼专区",
  lang409: "白虾专区",
  lang410: "板",
  lang411: "新手教程",
  lang412: "综合指数",
  lang413: "航线码",
  lang414: "行情价格",
  lang415: "市场资讯",
  lang416: "大盘价格",
  lang417: "区域价格",
  lang418: "历史价格",
  lang419: "全部品牌",
  lang420: "至",
  lang421: "开始日期",
  lang422: "结束日期",
  lang423: "人民币",
  lang424: "美元",
  lang425: "价格走势图",
  lang426: "地区",
  lang427: "单位:(元/吨)",
  lang428: "开市价",
  lang429: "闭市价",
  lang430: "最高价",
  lang431: "最低价",
  lang432: "成交均价",
  lang433: "行情区间",
  lang434: "国家",
  lang435: "**更新",
  lang436: "月",
  lang437: "日",
  lang438: "金砖国家项目背景及交易中心背景介绍",
  lang439: "金砖国家合作起源",
  lang440: "设立水产品交易中心的战略意义",
  lang441: "交易中心成立背景",
  lang442: "交易中心定位与目标",
  lang443: "金砖国家：从概念到全球经济重要力量的崛起",
  lang444:
    "2001 年，全球经济格局正经历着微妙而深刻的变化，美国高盛公司首席经济学家吉姆・奥尼尔在一份研究报告中，首次提出了 “金砖国家” 这一具有前瞻性的概念。当时，他敏锐地观察到巴西、俄罗斯、印度和中国这四个国家在全球经济中的潜力，将它们的英文名称首字母组合起来 ——Brazil（巴西）、Russia（俄罗斯）、India（印度）、China（中国），形成了 “BRIC”。由于这个缩写的发音与英文中的 “砖（BRICK）” 极为相似，“金砖四国” 的称呼便应运而生，形象地寓意着这四个国家如同坚实的砖块，将为全球经济的大厦添砖加瓦。",
  lang445:
    "“金砖四国” 概念的提出，并非偶然。彼时，这四个国家都展现出了强劲的经济增长势头：巴西凭借丰富的自然资源和农业优势，在拉美地区崭露头角；俄罗斯依托能源出口和军事工业基础，逐步走出经济低谷；印度以软件产业和服务业为引擎，开启了快速发展的篇章；中国则凭借改革开放的深入推进，成为全球制造业的重要基地和经济增长的核心动力。奥尼尔的这一概念，精准地捕捉到了新兴市场国家崛起的趋势，为全球经济观察提供了一个全新的视角。",
  lang446:
    "2006 年，在联合国大会期间，巴西、俄罗斯、印度和中国四国外长举行了首次会晤。这次会晤看似低调，却有着里程碑式的意义，它标志着 “金砖四国” 开启了实质性的合作序幕。此后，四国在政治、经济、金融等多个领域的合作不断深化，逐渐形成了定期磋商的机制，共同应对全球经济面临的挑战，维护新兴市场国家的共同利益。",
  lang447:
    "2010 年，南非正式加入 “金砖四国”，这一事件让 “金砖国家” 的合作机制更加完善，“BRIC” 也随之变为 “BRICS”。南非的加入，不仅扩大了金砖国家的地域覆盖范围，使其影响力延伸至非洲大陆，更丰富了金砖国家的合作内涵。从此，金砖国家合作机制正式形成，成为全球范围内一支不可忽视的新兴力量。",
  lang448:
    "金砖国家在全球范围内占据着举足轻重的地位。从国土面积来看，金砖国家的国土面积总和占世界领土总面积的 26.46%，广袤的土地上蕴藏着丰富的自然资源，为各国的经济发展提供了坚实的物质基础。在人口方面，金砖国家的人口总量占世界总人口的 41.93%，庞大的人口规模不仅意味着广阔的市场潜力，也为全球经济发展提供了充足的劳动力资源。",
  lang449:
    "随着时间的推移，金砖国家在全球经济格局中的影响力不断提升。以 2023 年的数据为例，按购买力平价计算，金砖国家占全球生产总值（GDP）的比例达到了 35.7%，这一比例超过了七国集团的 29%。这一显著的变化，充分体现了金砖国家经济实力的不断增强，也反映了全球经济重心逐渐从发达国家向新兴市场国家转移的趋势。",
  lang450:
    "如今，金砖国家已经成为推动全球经济增长、促进国际合作与多边主义的重要力量。在未来的发展中，金砖国家将继续深化合作，携手应对各种全球性挑战，为构建更加公平合理的国际经济秩序贡献力量。",
  lang451: "金砖国家水产品交易中心：助力渔业合作与发展的重要引擎",
  lang452:
    "在金砖国家合作不断深化的背景下，建立水产品交易中心成为推动各国渔业领域协同发展的关键举措。这一平台在促进贸易增长、优化资源配置和加强产业合作等方面发挥着不可替代的作用，为金砖国家水产品贸易的蓬勃发展注入强劲动力。",
  lang453:
    "从促进贸易增长的角度来看，交易中心能够有效整合各国资源，大幅减少贸易壁垒，推动金砖国家间水产品贸易额的进一步提升。金砖各国在水产品资源方面各具特色：巴西拥有丰富的热带雨林淡水渔业资源和漫长海岸线的海水产品；俄罗斯的北冰洋和远东海域盛产高品质冷水鱼类；印度的热带水产品种类繁多且产量可观；中国则在养殖水产品领域占据优势，南非的海洋渔业资源也独具特色。交易中心通过搭建统一的信息共享平台，将各国的水产品供应信息、市场需求、政策法规等集中整合，让买卖双方能够快速精准地对接。同时，交易中心可以推动各国在关税减免、检验检疫标准互认等方面达成共识，简化通关流程，降低贸易成本。例如，以往各国因检验检疫标准不一，导致部分水产品在跨境流通中受阻，交易中心可组织专家制定统一的行业标准，消除此类壁垒，让巴西的金枪鱼、俄罗斯的鳕鱼、印度的对虾、中国的鳗鱼等优质水产品在金砖国家间畅通无阻地流通，从而显著提升贸易额。",
  lang454:
    "在优化资源配置方面，交易中心借助平台作用，能使各国优势水产品更高效地流通到需求市场，实现资源的合理分配。金砖国家在水产品的生产和需求上存在明显的互补性。比如，中国对冷水鱼类的需求量较大，而俄罗斯在这方面供应充足；巴西市场对养殖虾类需求旺盛，印度则是养殖虾的重要生产国。交易中心通过大数据分析，精准掌握各国市场的需求动态，引导各国优势水产品按照市场规律流动。当印度的养殖虾产量过剩时，交易中心可迅速将信息传递给需求旺盛的巴西市场，促成交易；当中国的养殖水产品在满足国内需求后有剩余，交易中心能帮助其对接俄罗斯等有需求的国家。这种高效的流通机制，避免了资源的闲置和浪费，让每一个国家的优势水产品都能在最需要的地方发挥价值，实现了金砖国家范围内水产品资源的最优配置。",
  lang455:
    "交易中心对加强产业合作的推动作用也十分显著，它能带动上下游产业协同发展，促进金砖国家在渔业产业链上的深度合作。水产品贸易的繁荣不仅涉及产品的买卖，还关联着渔业养殖、加工、物流等上下游产业。交易中心的建立，为这些产业的协同发展搭建了桥梁。在渔业养殖领域，各国可以通过交易中心分享先进的养殖技术，如中国的稻田养鱼技术、巴西的生态养殖模式等，提升整体养殖水平；在加工产业方面，交易中心可促进各国加工企业的合作，俄罗斯的鱼类加工技术、中国的精深加工经验能够实现优势互补，提高水产品的附加值；在物流产业上，为了满足水产品保鲜和快速运输的需求，各国物流企业可以联合打造跨境冷链物流网络，交易中心则为物流资源的整合提供协调平台。通过这种上下游产业的协同发展，金砖国家在渔业产业链上的合作不断深化，形成了相互依存、互利共赢的产业生态体系。",
  lang456:
    "金砖国家水产品交易中心的建立，是顺应各国渔业发展需求、深化金砖合作的重要实践。它通过多维度的作用发挥，不仅推动了水产品贸易的增长，更促进了各国在渔业领域的深度融合，为金砖国家渔业产业的繁荣发展开辟了广阔前景。",
  lang457: "金砖国家水产品交易中心：成立的坚实基础与时代必然",
  lang458:
    "金砖国家在渔业领域的合作潜力巨大，成立水产品交易中心既是各国资源禀赋与市场需求的自然选择，也是应对全球竞争、深化合作机制的必然举措。这一平台的构建有着深厚的现实基础和鲜明的时代意义。",
  lang459:
    "金砖国家在渔业资源和水产品市场上的巨大潜力，为交易中心的成立提供了坚实的物质基础。各国水产品各具特色且互补性极强，形成了天然的合作纽带。俄罗斯坐拥广袤的北冰洋和太平洋海域，深海鱼类资源极为丰富，鳕鱼、三文鱼等冷水鱼类以肉质鲜美、营养丰富闻名全球；中国在淡水养殖领域积累了成熟技术，从稻田养鱼到工厂化养殖，产量和品质稳居世界前列，同时水产加工产业链完善，能将初级产品转化为多样化的深加工制品；印度地处热带，独特的气候条件孕育了丰富的热带水产品，对虾、罗非鱼等产量可观，深受国际市场青睐；巴西的亚马逊河流域和漫长海岸线，带来了丰富的淡水鱼和海水产品；南非周边海域的龙虾、鲍鱼等海珍品则独具地域特色。这种资源的多样性与互补性，让各国在水产品贸易中能各取所需，为交易中心的运作提供了充足的交易标的和广阔的市场空间，使得跨国家、跨品类的水产品流通具备了天然优势。",
  lang460:
    "在全球水产品贸易市场的竞争与机遇并存的当下，金砖国家急需一个统一高效的交易平台来提升整体竞争力，强化在国际市场的话语权。当前，全球水产品贸易格局复杂，既有欧盟、日本等传统市场的技术壁垒和贸易保护主义，也有东南亚国家在中低端产品市场的激烈竞争。金砖国家虽各自拥有优势产品，但分散的贸易模式难以形成合力，在价格谈判、标准制定等方面常处于被动地位。例如，中国的养殖水产品、俄罗斯的深海鱼类在国际市场上虽有竞争力，却因缺乏统一的议价平台，易受国际资本和中间商操控。而一个统一的交易中心，能整合各国出口资源，形成规模效应，通过集中采购、联合议价等方式提升议价能力。同时，平台可建立统一的质量认证体系和品牌推广机制，让金砖国家的水产品以整体形象参与国际竞争，从而在全球贸易规则制定中争取更多话语权，更好地把握全球水产品消费升级带来的机遇。",
  lang461:
    "随着金砖国家合作机制不断完善，在经贸、金融等多领域合作取得显著成果的背景下，成立水产品交易中心成为进一步深化务实合作的重要举措。近年来，金砖国家在经贸领域的合作持续升温，贸易额逐年攀升，金砖新开发银行等金融机构为跨境贸易提供了有力支撑。在这一良好态势下，渔业作为各国经济的重要组成部分，亟需一个专项平台来承接合作红利。此前，各国在农产品贸易、能源合作等领域已积累了丰富经验，这些成功实践为水产品交易中心的运作提供了可借鉴的模式。成立交易中心，能将金砖国家在经贸、金融领域的合作成果延伸至渔业领域，通过打通物流通道、简化结算流程、共享市场信息等方式，让务实合作落到实处。这不仅能丰富金砖国家合作的内涵，更能通过渔业产业链的联动，带动相关产业发展，为各国经济增长注入新动力，成为金砖合作 “提质升级” 的生动注脚。",
  lang462:
    "综上所述，金砖国家水产品交易中心的成立，是资源禀赋、市场需求与合作深化共同作用的结果。它的建成将推动各国渔业资源高效整合，提升全球竞争力，为金砖国家合作开辟更广阔的空间。",
  lang463: "金砖国家水产品交易中心的定位与目标",
  lang464:
    "金砖国家水产品交易中心定位为全球领先的金砖国家水产品集中交易平台，具备多元化的功能体系。该平台集信息发布、交易撮合、质量检测、物流配送、金融服务等多重功能于一体，形成完整的水产品贸易服务闭环。",
  lang465:
    "在信息发布方面，平台将实时整合金砖各国水产品供求数据、价格波动、政策动态等信息，为企业提供精准的市场指引；交易撮合功能通过智能化匹配系统，打破地域限制，高效连接买卖双方，简化交易流程；质量检测环节依托统一的标准体系，对进出口水产品进行严格检测，保障产品安全；物流配送网络则整合各国物流资源，构建跨境冷链运输通道，确保水产品新鲜度；金融服务板块引入金砖新开发银行等机构，提供结算、融资、保险等服务，解决贸易中的资金难题。",
  lang466:
    "交易中心的核心目标是打造成为金砖国家渔业经济合作的核心枢纽。通过整合各国渔业资源，推动产业链上下游协同，促进技术交流与标准对接，实现金砖国家渔业经济的深度融合。未来，该中心将成为各国渔业政策协调的对话平台、企业合作的桥梁纽带以及全球水产品贸易的重要支点，助力金砖国家在渔业领域形成合力，提升整体竞争力，为全球渔业可持续发展贡献力量。",
  lang467: "平台规则",
  lang468: "金砖国际渔业交易平台",
  lang469: "打造全球领先的金砖国家水产品交易平台，促进国际贸易合作与发展",
  lang470: "立即交易",
  lang471: "进口方案",
  lang472: "海外代理进口服务",
  lang473:
    "主要进口品类为：水产品进口（南美白对虾、鱼蟹等）、肉制品进口(牛肉、羊肉、猪肉等)、禽类进口（鸡、鸭、鹅等）。",
  lang474: "代·采｜询盘议价",
  lang475: "代·付｜跨境付汇",
  lang476: "代·理｜进口清关",
  lang477: "代·运｜物流跟踪",
  lang478: "代·管｜仓储资源",
  lang479: "四流合一·全程可视",
  lang480: "提供一站式专业进口水产贸易方案",
  lang481: "信息流",
  lang482: "海外优质水产品推荐",
  lang483: "境外服务服务商资源",
  lang484: "国内水产品需求匹配",
  lang485: "资金流",
  lang486: "外币付汇资质",
  lang487: "业务货款垫资",
  lang488: "供应链金融服务",
  lang489: "物流",
  lang490: "国际货运定位跟踪",
  lang491: "冷链物流实时同步",
  lang492: "最优路径决策",
  lang493: "服务流",
  lang494: "智能合约",
  lang495: "服务流程可视",
  lang496: "数字化服务",
  lang497: "业务优势",
  lang498: "专注进口水产及冻品贸易，南美白对虾综合进口量全国领先",
  lang499:
    "专业做水产及冻品进口代理、代采业务，我们拥有众多海外水产及冻品供应商资源，专业资深的国外贸易顾问团队沟通报盘，稳定的供应渠道和强大的议价能力让采购环节更具廉价、高效、快捷，可以实实在在地为客户省钱。",
  lang500: "一站式代理代采进口业务，轻松实现全球买、全球卖",
  lang501:
    "拥有合法合规的进出口权和付汇资质，专业多对一VIP跟踪服务，可以实现进口订单业务的全流程实时跟踪，信息可视化、物流可视化、资金可视化。强大的大宗水产交易中心提供销货渠道资源，从买到卖一条龙服务，让水产交易更加的省心省力。",
  lang502: "休市中",
  lang503: "开市时间 周一到周六 早上9:00-下午17:00",
  lang504: "集单",
  lang505: "挂牌",
  lang506: "竞价",
  lang507: "交易类型",
  lang508: "订单",
  lang509: "专区",
  lang510: "全部专区",
  lang511: "排序",
  lang512: "筛选",
  lang513: "品类/品项/规格",
  lang514: "综合排序",
  lang515: "价格由低到高",
  lang516: "价格由高到低",
  lang517: "全部状态",
  lang518: "你好，欢迎登录 金砖国际渔业交易平台",
  lang519: "验证码",
  lang520: "手机号",
  lang521: "获取验证码",
  lang522: "**S后重新获取",
  lang523: "密码",
  lang524: "已阅读并同意",
  lang525: "手机号格式错误",
  lang526: "请输入验证码",
  lang527:
    "请阅读并同意《个人信息保护及隐私政策》《用户服务协议》《信息服务协议》《整体规则汇总试用》",
  lang528: "加载中...",
  lang529: "原",
  lang530: "半",
  lang531: "已出售",
  lang532: "生产日期",
  lang533: "捕捞时间",
  lang534: "年",
  lang535: "捕捞方式",
  lang536: "冷冻",
  lang537: "捕捞海域",
  lang538: "包装方式",
  lang539: "切割",
  lang540: "是否带膜",
  lang541: "选择并带入此记录",
  lang542: "货源详情",
  lang543: "货源方",
  lang544: "货源方客户",
  lang545: "船号",
  lang546: "冷库",
  lang547: "是否包船货源",
  yes: "是",
  no: "否",
  lang548: "自营属性",
  lang549: "开放",
  lang550: "非开放",
  lang551: "编号",
  lang552: "品牌",
  lang553: "更多信息",
  lang554: "其他补充信息",
  lang555: "金枪鱼",
  lang556: "进口秘鲁",
  lang557: "请输入关键词...",
  lang558: "搜索",
  lang559: "按客户分",
  lang560: "按规格分",
  lang561: "如需新增自营货源,请前往小黑板新增",
  lang562: "售完",
  lang563: "结余",
  lang564: "更新时间",
  lang565: "单位:吨",
  lang567: "流转预警",
  lang568: "等待流转",
  lang569: "总计：",
  lang570: "已售",
  lang571: "总量",
  lang572: "当前负责人",
  lang573: "全部资讯",
  lang574: "近7天最热",
  lang575: "历史最热",
  lang576: "相关新闻",
  lang577: "更多新闻",
  lang578: "开始",
  lang579: "竞价进行中...",
  lang580: "倒计时",
  lang581: "本轮倒计时",
  lang582: "距离开始还有",
  lang583: "决策时间",
  lang584: "竞价已结束",
  lang585: "不可拆分",
  lang586: "本轮价格",
  lang587: "**人报名",
  lang588: "**次围观",
  lang589: "**次求购",
  lang590: "预计**时候到达@@",
  lang591: "生产国家",
  lang592: "售卖方式",
  lang593: "件重",
  lang594: "箱数",
  lang595: "生产时间",
  lang596: "入库时间",
  lang597: "冷冻方式",
  lang598: "切割方式",
  lang599: "规格占比及大小",
  lang600: "包装形式",
  lang601: "付款模式",
  lang602: "定金模式",
  lang603: "定金**元",
  lang604: "全款模式",
  lang605: "订单描述",
  lang606: "收起",
  lang607: "买方需另行支付平台服务费，收费标准为",
  lang608: "实际费用依具体情形确定 ",
  lang609: "如需资金支持，请联系平台客服进行咨询",
  lang610: "本单支持金融支付",
  lang611:
    "本订单支持金融支付服务。若您存在垫款需求，可在进行购买操作时填写垫款申请表。提交申请后，银行将依据相关标准和流程对您的申请展开评估与审核。审核通过并获得授信后，您即可获取等同于货款金额70%的垫款支持，以便顺利完成本次交易。",
  lang612: "还有没有别的货源?",
  lang613: "问问看",
  lang614: "开市时间",
  lang615: "普通支付",
  lang616: "金融支付",
  lang617: "本单支持线上支付",
  lang618: "我要报名",
  lang619: "请等待下一轮",
  lang620: "价格满意！可以跟！",
  lang621: "取消跟价",
  lang622: "确认跟价",
  lang623: "电话呼叫经纪人",
  lang624: "联系专属经纪人",
  lang625: "获取详细资料",
  lang626: "货物解标报告",
  lang627: "货物解标视频",
  lang628: "出价记录",
  lang629: "序号",
  lang630: "状态",
  lang631: "领先",
  lang632: "淘汰",
  lang633: "出价人",
  lang634: "我",
  lang635: "变动",
  lang636: "变动后价格",
  lang637: "变动时间",
  lang638: "跟价人数",
  lang639: "(已跟)",
  lang640: "报盘详情",
  lang641: "仅看我的",
  lang642: "认购吨数",
  lang643: "编辑报盘",
  lang644: "交易详情",
  lang645: "进口集单",
  lang646: "交易编号",
  lang647: "出价幅度",
  lang648: "竞拍时间",
  lang649: "竞拍时长",
  lang650: "分钟",
  lang651: "每一轮思考是否跟价的时间。",
  lang652: "秒钟",
  lang653: "延时周期",
  lang654: "上传时间",
  lang655: "成交时间",
  lang656: "内部客户",
  lang657: "客户主体",
  lang658: "定时上架",
  lang659: "货源库单",
  lang660: "确认成交后可查看",
  lang661: "共**张",
  lang662: "外包装袋",
  lang663: "一键下载所有图片",
  lang664: "货源标签",
  lang665: "货源图片/视频",
  lang666: "品控报告",
  lang667: "资质手续",
  lang668: "动态竞价规则",
  lang669: "出价流程",
  lang670:
    "每一轮竞价均由系统率先出价，出价完成后，买方将拥有<span>**秒</span>的决策时间，在此期间需决定是否跟价。",
  lang671: "无人跟价情况",
  lang672:
    "若在规定的<span>** 秒</span>决策时间内，无买方选择跟价，那么竞价将进入下一轮，且下一轮的价格会降低。",
  lang673: "多人跟价情况",
  lang674:
    "若在<span>**秒</span>内有多个买方选择跟价，竞价同样进入下一轮，且下一轮的价格将会升高。",
  lang675: "特殊判定规则",
  lang676:
    "若出现连续两次相同低价都有多人跟价，且随后的高价无人跟价的情况，那么在第三次出现该低价时，最先进行跟价的买方将获拍。",
  lang677: "保留价原则",
  lang678:
    "在竞价过程中，若价格因无人跟价而持续降低，直至达到或低于事先设定的保留价 ，且此时仍无人跟价，则本次交易流拍。",
  lang679: "统一价格有效性",
  lang680:
    "在本次竞价活动中，无论处于何种场次，只要买方在某一价格上进行跟价，该跟价始终有效。这意味着，一旦某个价格被买方跟价，此价格在后续的竞价流程中都会作为有效价格参与整个竞价体系，直至最终成交或流拍。",
  lang681: "联系人",
  lang682: "联系方式",
  lang683: "恭喜获拍",
  lang684: "订单确认中",
  lang685: "跟价详情",
  lang686: "跟价顺序",
  lang687: "继承",
  lang688: "关闭",
  lang689: "盒",
  lang690: "箱",
  lang691: "货源照片",
  lang692: "外包装",
  lang693: "标签",
  lang694: "报名成功",
  lang695: "选择品类",
  lang696: "选择交易形式",
  lang697: "下一步",
  lang698: "自营资源",
  lang699: "看货记录",
  lang700: "订单设置",
  lang701: "货源设置",
  lang702: "看货编号",
  lang703: "清空",
  lang704: "订单名称",
  lang705: "吨数",
  lang706: "定重",
  lang707: "过磅",
  lang708: "扣重",
  lang709: "其它",
  lang710: "产地名称",
  lang711: "捕捞日期",
  lang712: "选择年",
  lang713: "选择月",
  lang714: "选择件重",
  lang715: "平均克重(g)",
  lang716: "规格占比及大小",
  lang717:
    "请写出货源包含的规格占比及大小情况，例如：“规格100-150占比25%，偏大；规格200-3000占比75%，正常大小。",
  lang718: "收货地址",
  lang719: "资质手续(报关单、检疫单等)",
  lang720: "数据报告",
  lang721: "卖家只能在竞价开始前报名，请预留足够时间。",
  lang722: "竞价日期",
  lang723: "竞价时间",
  lang724: "任意时间点",
  lang725: "竞价时长(分钟)",
  lang726: "请输入竞价时长",
  lang727: "决策时间（秒）",
  lang728: "货币",
  lang729: "人民币 CNY",
  lang730: "美元 USD",
  lang731: "确定价格",
  lang732: "已确定",
  lang733: "暂无",
  lang734: "价格（美元/吨）",
  lang735: "交易达成后，平台会按照5美元/吨向您收取服务费。",
  lang736: "履约保证金",
  lang737:
    "履约保证金是确保交易平稳、有序开展的重要保障。在交易完成达成成交状态，或卖家主动将商品下架的情况下，系统会按照原支付路径，将履约保证金全额退回。",
  lang738: "限免",
  lang739: "余额不足，去充值",
  lang740: "降价幅度",
  lang741: "保留价",
  lang742: "参拍保证金（元）",
  lang743: "预计到港时间",
  lang744: "到货港口",
  lang745: "发布方式",
  lang746: "立即发布",
  lang747: "定时交易",
  lang748: "交易开始",
  lang749: "选择日期时间",
  lang750: "是否拆分",
  lang751: "求购方式",
  lang752: "拆分售卖",
  lang753: "最小成交量",
  lang754: "吨整倍数",
  lang755: "不低于",
  lang756: "吨",
  lang757: "下架方式",
  lang758: "小于",
  lang759: "吨后，自动下架",
  lang760: "手动下架",
  lang761: "定金百分比（%）",
  lang762: "货物库单",
  lang763: "提交后等待审核",
  lang764: "请选择品类",
  lang765: "请选择货源名称",
  lang766: "请输入数字，最多包含四位小数",
  lang767: "请选择竞价日期",
  lang768: "请选择竞价时间",
  lang769: "请选择地址",
  lang770: "请选择发布方式",
  lang771: "请选择交易开始时间",
  lang772: "请输入最小成交倍数",
  lang773: "请输入最小成交量",
  lang774: "请选择下架方式",
  lang775: "请输入自动下架需满足的吨数",
  lang776: "请选择付款模式",
  lang777: "请输入定金金额百分比",
  lang778: "请选择币种",
  lang779: "请输入报名费",
  lang780: "请输入数字，最多包含两位小数",
  lang781: "请输入决策时间",
  lang782: "请输入保留价",
  lang783: "请选择是否接受金融支付",
  lang784: "请选择是否确定价格",
  lang785: "请输入预计到港时间",
  lang786: "请输入到货港口",
  lang787: "请选择冷库",
  lang788: "阿根廷红虾专区",
  lang789: "1月",
  lang790: "2月",
  lang791: "3月",
  lang792: "4月",
  lang793: "5月",
  lang794: "6月",
  lang795: "7月",
  lang796: "8月",
  lang797: "9月",
  lang798: "10月",
  lang799: "11月",
  lang800: "12月",
  lang801: "普通挂牌",
  lang802: "普通竞价",
  lang803: "动态竞价",
  lang804: "请选择专区",
  lang805: "钩钓",
  lang806: "网捕",
  lang807: "灯光",
  lang808: "统货",
  lang809: "上传图片异常",
  lang810: "阿根廷鱿鱼",
  lang811: "真鱿",
  lang812: "印度洋鱿鱼",
  lang813: "四去头",
  lang814: "五去头",
  lang815: "生耳",
  lang816: "生片",
  lang817: "克重信息（小）不能大于克重信息（大）",
  lang818: "请输入完整的平均克重信息",
  lang819: "定重,件重,",
  lang820: "过磅,扣重,",
  lang821: "请输入完整的售卖方式信息",
  lang822: "请输入完整的件重信息",
  lang823: "请上传货源照片",
  lang824: "请上传货物库单照片",
  lang825: "服务异常，请联系管理员～",
  lang826: "默认",
  lang827: "第一步：选择开户类型",
  lang828: "开户类型",
  lang829: "企业",
  lang830: "个体工商",
  lang831: "第二步：上传身份信息",
  lang832: "请上传身份证",
  lang833:
    "1.照片要清晰完整，文字、数字、图案等信息清晰可辨，无模糊、重影、遮挡。",
  lang834: "2.需为原件清晰彩色照片，黑白、复印件照片无效。",
  lang835: "姓名",
  lang836: "请输入正确的手机号",
  lang837: "请检查法人手机号",
  lang838: "请上传营业执照",
  lang839: "请上传法人身份证人像面",
  lang840: "请上传法人身份证国徽面",
  lang841: "请上传经办人身份证人像面",
  lang842: "请上传经办人身份证国徽面",
  lang843: "请上传身份证人像面",
  lang844: "请上传身份证国徽面",
  lang845: "请阅读并勾选协议",
  lang846: "请上传银行卡照片",
  lang847: "账户关联",
  lang848: "主账号信息",
  lang849: "（当前登录账号）",
  lang850: "主体名称",
  lang851: "法人",
  lang852: "主体账号",
  lang853: "子账号列表",
  lang854: "添加账号",
  lang855: "角色",
  lang856: "查看",
  lang857: "解绑账号",
  lang858: "子账号角色",
  lang859: "财务",
  lang860: "交易员",
  lang861: "账号负责人",
  lang862: "绑定手机号",
  lang863: "账号负责人信息",
  lang864:
    "需保证照片内容真实有效，不得做任何修改仅支持jpg、gif、png、jpeg图片格式，图片大小不能超过10M。",
  lang865: "请上传身份证的正反面",
  lang866: "请完善以下信息",
  lang867: "身份证号码",
  lang868: "身份证截止日期",
  lang869: "负责人手机号",
  lang870: "请输入（非当前登录账号）",
  lang871: "再次输入以确认填写内容",
  lang872: "当前账号手机号",
  lang873: "手机验证码",
  lang874: "《子账户添加协议》",
  lang875: "提交子账号信息",
  lang876: "请选择角色",
  lang877: "重新发送",
  lang878: "请上传身份证证人像面",
  lang879: "请上传身份证证国徽面",
  lang880: "请阅读并勾选相关协议",
  lang881: "两次输入的手机号不一致",
  lang882: "此操作将解绑该账号, 是否继续?",
  lang883: "解绑成功",
  lang884: "交易日期",
  lang885: "类型",
  lang886: "金额",
  lang887: "流水号",
  lang888: "账户余额",
  lang889: "当前主体",
  lang890: "账户实际余额（元）",
  lang891: "在途金额（元）",
  lang892: "冻结金额（元）",
  lang893: "账户充值",
  lang894: "我要提现",
  lang895: "账户明细",
  lang896: "充值流程",
  lang897: "已绑定的卡",
  lang898: "第一步 确定已绑定银行卡",
  lang899: "重新验证",
  lang900: "待打款验证",
  lang901: "一键换绑",
  lang902: "我的账户",
  lang903: "第二步 使用以上银行卡向如下账户汇款",
  lang904: "账户名",
  lang905: "账号",
  lang906: "开户行",
  lang907: "一键复制账户信息",
  lang908: "点击查看具体充值教程",
  lang909: "企业转账",
  lang910: "个人转账",
  lang911: "中国农业银行",
  lang912: "在中国农业银行APP首页中，点击“转账”图标",
  lang913: "进入到转账页面后，点击“账号转账”",
  lang914: "在账号转账页面中，填写信息，收款银行搜索“江苏苏商银行”，进行充值。",
  lang915: "中国工商银行",
  lang916: "在中国工商银行APP首页中，点击“转账汇款”图标",
  lang917: "进入转账汇款页面，点击“境内汇款”",
  lang918:
    "在境内汇款页面中，填写信息，将会自动识别银行，若未能成功识别“江苏苏商银行”，请搜索“江苏苏商银行”并选择，然后进行充值。",
  lang919: "中国银行",
  lang920: "在中国银行APP首页中，点击“转账”图标",
  lang921: "进入转账汇款页面，点击“账号转账”",
  lang922:
    "在账号转账页面中，填写信息，将会自动识别银行，若未能成功识别“江苏苏商银行”，请搜索“江苏苏商银行”并选择，然后进行充值。",
  lang923: "中国建设银行",
  lang924: "在中国建设银行APP首页中，点击“转账汇款”图标",
  lang925: "进入转账汇款页面，点击“银行账号转账”",
  lang926:
    "在账号转账页面中，填写信息，将会自动识别银行，若未能成功识别“江苏苏商银行”，请搜索“江苏苏商银行”并选择，然后进行充值。",
  lang927: "确定要解绑吗？",
  lang928: "成功复制！",
  lang929: "无法复制！",
  lang930: "到账银行卡",
  lang931: "提现金额",
  lang932: "当前可提现金额",
  lang933: "全部提现",
  lang934:
    " 中国人民银行大额支付系统于工作日17:15—20:30 以及节假日暂停对外服务。在此期间，若您有单笔超过100万元的提现需求，请分批进行提现操作。",
  lang935: "请选择到账银行卡",
  lang936: "请输入提现金额",
  lang937: "我买入的",
  lang938: "我卖出的",
  lang939: "订单详情",
  lang940: "速算单号",
  lang941: "此订单",
  lang942: "订单创建时间",
  lang943: "贷前须知：贷款年化利率： 4.2%",
  lang944:
    "*中国建设银行不收取除利息外的任何费用,未委托任何公司向客户代为收取费用.",
  lang945: "实际交割数量",
  lang946: "总货值",
  lang947: "首付款",
  lang948: "定金",
  lang949: "首次支付",
  lang950: "首次收款",
  lang951: "待支付",
  lang952: "等待买家支付",
  lang953: "已支付",
  lang954: "已到账",
  lang955: "合计支付",
  lang956: "合计收款",
  lang957: "优惠券",
  lang958: "成单人",
  lang959: "支付记录",
  lang960: "收款记录",
  lang961: "费用类型",
  lang962: "发票记录",
  lang963: "上传发票",
  lang964: "发票名称",
  lang965: "提货申请",
  lang966: "支付服务费",
  lang967: "预授信签署",
  lang968: "签署合同",
  lang969: "去支付",
  lang970: "操作日志",
  lang971: "图像格式：PNG、JPG、JPEG、PDF。",
  lang972: "图像大小：不超过3 MB。",
  lang973: "图像分辨率：大于15×15 像素，小于4096x4096 像素。",
  lang974: "确定上传",
  lang975: "发票",
  lang976: "确定要删除该发票吗？",
  lang977: "仅允许上传一张，请删除后重新上传",
  lang978: "待交割",
  lang979: "待付款",
  lang980: "已完成",
  lang981: "查看详情",
  lang982: "还款提货",
  lang983: "我发布的交易",
  lang984: "待审核",
  lang985: "展示中",
  lang986: "已结束",
  lang987: "驳回",
  lang988: "我的交易（买）",
  lang989: "我的交易（卖）",
  lang990: "服务升级",
  lang991: "为了给您提供更优质的服务体验，",
  lang992: "并确保我们的合作更加顺畅和合规，",
  lang993: "现邀请您升级账户。",
  lang994: "请点击【补充签署《开户协议》】",
  lang995: "请提醒账号",
  lang996: "注意查收短信，",
  lang997: "并根据短信提示完成签署，",
  lang998: "感谢您的支持与配合。",
  lang999: "补充签署《开户协议》",
  lang1000: "重新发起验证",
  info1: "经办人手机号",
  info2: "获取验证码",
  info3: "去开户",
  info4: "开户后即可在平台完成交易",
  info5: "开户失败，需要重新开户",
  info6: "打款失败",
  info7: "去验证",
  info8: "打款验证失败",
  info9: "处理中",
  info10: "审核失败",
  info11: "待小额打款",
  info12: "受理中",
  info13: "发送协议",
  info14: "需要法人签署《开户协议》",
  info15: "需要法人签署《开户协议》",
  info16: "等待法人签署《开户协议》",
  info17: "验证码不能为空",
  info18: "个人首页",
  info19: "账号关联",
  info20: "我发布的",
  info21: "我报名的竞价",
  info22: "我点赞的文章",
  info23: "退出登录",
  info24: "未成交",
  info25: "还款提货",
  info26: "可提数量（吨）",
  info27: "品类品项规格",
  info28: "入库数量（吨）",
  info29: "剩余数量（吨）",
  info30: "申请中重量（吨）",
  info31: "冷库名称",
  info32: "入库日期",
  info33: "库内位置",
  info34: "物料编号",
  info35: "物流单号",
  info36: "物流车牌号",
  info37: "物流司机姓名",
  info38: "物流开始运输时间",
  info39: "物流到达时间",
  info40: "出库记录",
  info41: "提货吨数",
  info42: "全部提出",
  info43: "提交申请后，平台会有专员与您联系，请稍后",
  info44: "剩余库存",
  info45: "出库单号",
  info46: "请输入提货吨数",
  info47: "请选择提货日期",
  info48: "提货成功",
  info49: "身份证有效期",
  info50: "职业",
  info51: "第二步：上传基础信息",
  info52: "公司名称",
  info53: "营业期限",
  info54: "注册地址",
  info55: "社会统一信用代码",
  info56: "注册资本",
  info57: "企业联系电话",
  info58: "请上传法人身份证",
  info59: "法人姓名",
  info60: "法人身份证号",
  info61: "法人本人需要签署《开户协议》,请确认手机号正确无误。",
  info62: "法人手机号",
  info63: "法人手机号确认",
  info64: "请上传经办人身份证",
  info65: "经办人姓名",
  info66: "经办人身份证号",
  info67: "身份证有效期",
  info68: "第三步：绑定银行卡",
  info69: "发送验证码",
  info70:
    "已阅读并同意《江苏苏商银行场景支付业务会员账簿服务协议》的全部内容并接受该协议的约束",
  info71: "开户成功",
  info72: "完成",
  info73: "鱿鱼",
  info74: "鳕鱼",
  info75: "白虾",
  info76: "元",
  info77: "此操作将删除该报盘, 是否继续?",
  info78: "交易达成后，平台会按照50元/吨向您收取服务费。",
  info79: "鲱鱼专区",
  info80: "鲱鱼",
  info81: "议价价格",
  info82: "议价记录",
};



// WEBPACK FOOTER //
// ./src/lang/zh.js